import { useQuery } from '@tanstack/react-query';
import adminHttp from '../../../utils/adminHttp';

type Props = { userId: string };

export function useGetAdminUserDetails({ userId }: Props) {
  const { data, isLoading, ...rest } = useQuery({
    queryKey: ["get admin user details"],
    queryFn: async () => {
      const response = await adminHttp.get(`admins/admin/${userId}`);
      return response.data;
    },
    staleTime: Infinity,
  });
  return {
    adminUserData: data,
    isLoading,
    ...rest,
  }
}